import type { ProgramDto } from "common/models/api/models/ProgramDto";
import { useRef } from "react";
import { FormScaffoldProps } from "ui/common/components/layout/FormScaffold/FormScaffold.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import { ProgramFormGridNames } from "../ProgramFormGrid.types";

export default function useProgramFormGridRows() {
    const translate = useTranslate();

    const rows = useRef([
        {
            label: translate("image"),
            input: "image",
            alt: "program-image",
            name: ProgramFormGridNames.LOGO,
            required: false,
        },
        {
            label: translate("company"),
            input: "textfield",
            required: true,
            name: ProgramFormGridNames.COMPANY,
            bold: true,
        },
        {
            label: translate("nameProgram"),
            input: "textfield",
            name: ProgramFormGridNames.NAME,
            bold: true,
        },
        {
            label: translate("programAdminName"),
            input: "textfield",
            name: ProgramFormGridNames.ADMIN_NAME,
            bold: true,
            viewOnly: true,
        },
        {
            label: translate("programAdminPhone"),
            input: "textfield",
            name: ProgramFormGridNames.ADMIN_PHONE,
            bold: true,
            viewOnly: true,
        },
        {
            label: translate("programAdminEmail"),
            input: "textfield",
            required: true,
            name: ProgramFormGridNames.ADMIN_EMAIL,
            bold: true,
            viewOnly: true,
        },
        {
            label: translate("programAdminWebsite"),
            input: "textfield",
            name: ProgramFormGridNames.URL,
            bold: true,
        },
        {
            label: translate("programExpenditureApprover"),
            input: "textfield",
            required: false,
            name: ProgramFormGridNames.APPROVER,
            bold: true,
            viewOnly: true,
        },
        {
            label: translate("programMinAmountAllowed"),
            input: "textfield",
            required: true,
            name: ProgramFormGridNames.MIN_AMOUNT,
            validators: { number: true },
            bold: true,
            popover: translate("minValueHeadTooltip"),
        },
        {
            label: translate("programMaxAmountToRecharge"),
            input: "textfield",
            required: false,
            name: ProgramFormGridNames.MAX_AMOUNT,
            validators: { number: true },
            bold: true,
        },
    ]).current as FormScaffoldProps<ProgramDto>["rows"];
    return rows;
}
